
import HomeSection from "../components/HomeSection";
import News from "../components/News";
import { ParallaxProvider, Parallax } from 'react-scroll-parallax';
import styled from '@emotion/styled';
import logoCapa from "../assets/logos/capacitacion-logo.png";
import Resources from "../components/Resources";
import EspaldaAlumnos from "../assets/images/Transitions/EspaldaAlumnos.jpg";
import FrenteAlumnos from "../assets/images/Transitions/FrenteAlumnos.jpg";
import Calendar from "../components/Calendar";
import HomeInstructors from "../components/HomeInstructors";
import CNCSections from "../components/CNCSections";


const HomePage = ({ setPageType, pageType }) => {

  const ImgDiv = styled.div`
  width: 100%;
  height: 12.5em;
  display: flex;
  align-items: center;
  overflow:hidden;
  justify-content: center;
`;

const Logo = styled.img`
height: 80px;

position: absolute;

`;

const isMobile = window.innerWidth <= 768;


  return (
      <>
      <HomeSection pageType={pageType} setPageType = {setPageType}/>
      <CNCSections/>
      <ImgDiv>
        <ParallaxProvider>
          <Parallax speed={isMobile ? 0 : -200}><img src={EspaldaAlumnos} alt="Parallax" style={{ width: '100%' }} /></Parallax>
        </ParallaxProvider>
        <Logo src={logoCapa} alt="Logo Capa" />
      </ImgDiv>
      <News/>
      <ImgDiv>
        <ParallaxProvider>
          <Parallax speed={isMobile ? 0 : -200}><img src={FrenteAlumnos} alt="Parallax" style={{ width: '100%' }} /></Parallax>
        </ParallaxProvider>
        <Logo src={logoCapa} alt="Logo Capa" />
      </ImgDiv>
      <Resources/>
      <ImgDiv>
        <ParallaxProvider>
          <Parallax speed={isMobile ? 0 : -200}><img src={EspaldaAlumnos} alt="Parallax" style={{ width: '100%' }} /></Parallax>
        </ParallaxProvider>
        <Logo src={logoCapa} alt="Logo Capa" />
      </ImgDiv>
      <Calendar/>
      <HomeInstructors pageType={pageType} setPageType = {setPageType} />
      </>
  );
};

export default HomePage;